import React, { useContext } from "react";
import ProductContext from "../../context/product/productContext";
import UserContext from "../../context/user/userContext";
import { getCurrencySign } from "../../utils/helpers";
import {
  CloseIcon,
  DetailsBlock,
  DetailsCell,
  ImageBlock,
  Name,
  PriceCell,
  QuantityCell,
  SelectButton,
  SpanButton,
  StyledImage,
  StyledRow,
  Text,
  Value,
} from "./ProductRow.styles";

const ProductRow = ({ id, itemName, price = 0, imageUrl, details, productTotal = 0, quantity }) => {
  const {
    user: { currency },
  } = useContext(UserContext);
  const { addCount, removeCount, removeFromCart } = useContext(ProductContext);

  return (
    <StyledRow>
      <DetailsBlock>
        <ImageBlock>
          <StyledImage src={imageUrl} alt={itemName} />
          <CloseIcon
            src="/svgs/close.svg"
            alt="close"
            width={12}
            height={12}
            onClick={() => removeFromCart(id)}
          />
        </ImageBlock>
        <DetailsCell>
          <Name>{itemName}</Name>
          <Text>color: {details.color}</Text>
          <Text>size : {details.size?.toUpperCase()}</Text>
        </DetailsCell>
      </DetailsBlock>

      <PriceCell>{`${getCurrencySign(currency)}${parseInt(price).toFixed(2)}`}</PriceCell>

      <QuantityCell>
        <SelectButton>
          <SpanButton onClick={() => removeCount(id, quantity)}>−</SpanButton>
          <Value>{quantity}</Value>
          <SpanButton onClick={() => addCount(id)}> + </SpanButton>
        </SelectButton>
      </QuantityCell>

      <PriceCell>{`${getCurrencySign(currency)}${parseInt(productTotal).toFixed(2)}`}</PriceCell>
    </StyledRow>
  );
};

export default ProductRow;
